export { default as NewSectionNotification } from './newSectionNotification';
export { default as NewDocumentNotification } from './newDocumentNotification';

export * from './messages';
export * from './types';

export { isNotificationAllowed } from './configuration';
